import React from 'react';
import { formatMinutes, getTotalTimeMinutes } from '../../utils/recipeUtils';
import { useLanguage } from '../../i18n/LanguageContext';

const RecipeMetaPanel = ({ recipe }) => {
  const { lang, t } = useLanguage();
  const rd = t.recipeDetail;

  if (!recipe) {
    return null;
  }

  const metaItems = [
    { label: rd.prepTime, value: formatMinutes(recipe.prepTime, lang) },
    { label: rd.cookTime, value: formatMinutes(recipe.cookTime, lang) },
    { label: rd.totalTime, value: formatMinutes(getTotalTimeMinutes(recipe), lang) },
    { label: rd.servings, value: recipe.servings ? `${recipe.servings}` : '—' },
    { label: rd.creator, value: recipe.recipeUserName || rd.creatorFallback },
  ];

  return (
    <section className="recipe-meta-panel">
      <h3>{rd.snapshotTitle}</h3>
      <dl>
        {metaItems.map((item) => (
          <div key={item.label} className="recipe-meta-row">
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </dl>
      {recipe.tags?.length ? (
        <div className="recipe-tag-list" aria-label="Recipe tags">
          {recipe.tags.map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>
      ) : null}
    </section>
  );
};

export default RecipeMetaPanel;
